import React from 'react';
import {useSurveyContext} from "../../../context/SurveyContext";
import {isQuestionShown} from "../../../utils/questionnaireUtils";
import InfoBox from "../InfoBox";
import RadioButton from "../../RadioButton";
import Question from "./Question";

function RadioQuestion(props) {
    const {survey: {answers, passenger}, setAnswer} = useSurveyContext();
    const answer = answers[props.question.id];
    const nestedQuestions = answer && props.question.questions && props.question.questions[answer]?.filter(isQuestionShown(passenger));

    const isShown = props.question.part === props.activePart;

    return (
        <div>
            <div className={isShown ? "" : "hidden"} onBlur={() => props.validate(props.question, answer)}>
                <div className="text-lg text-grey-darker">
                    {props.question.questionText}
                </div>


                {props.question.questionInfo &&
                <InfoBox
                    classes="mt-6 md:inline-block"
                    infoText={props.question.questionInfo}
                    description={props.question.infoDescription}
                />
                }

                <div>
                    {props.question.options.map(option =>
                        <div key={option} className="mt-4">
                            <RadioButton
                                label={option}
                                _onChange={() => setAnswer(props.question.id, option)}
                                isSelected={answer === option}
                            />
                        </div>
                    )}
                </div>

                {props.question.answersInfo && props.question.answersInfo[answer] &&
                <InfoBox
                    classes="mt-6 md:inline-block"
                    infoText={props.question.answersInfo[answer]}
                />
                }
            </div>

            {nestedQuestions &&
            <div>
                {nestedQuestions.map(question =>
                    <Question
                        key={question.id}
                        activePart={props.activePart}
                        question={question}
                    />
                )}
            </div>
            }
        </div>
    )
}

export default RadioQuestion;